import React, { useEffect, useState } from "react";

import { useDispatch } from "react-redux";
import { ProfileSubmenuDropDown } from "../../Redux/Slice/PostSlice";
import HttpClient from "../../utils/HttpClient";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { OnetoOneChatIdname } from "../../Redux/Slice/Chat";
import call from "../../Images/Call.png";
import chatIcon from "../../Images/chatIcon.png";
import { confirmAlert } from 'react-confirm-alert'

export default function ProfileActionPop({ contact, reloadList }) {
    const dispatch = useDispatch();
    const [deleteWhatsappModalOpenClose, setdeleteWhatsappModalOpenClose] = useState(false);
    const navigate = useNavigate();
    const [clickedIndex, setClickedIndex] = useState(null);

    const openDelet = (index, nmbr) => {
        setdeleteWhatsappModalOpenClose(true);
        setClickedIndex(index === clickedIndex ? null : index);
    };

    const whatsAppRedirection = async (e, whats_code, whatsappNmbr, id) => {
        const whatsappNumber = whats_code + whatsappNmbr;

        const message = "Hi, I am Using Neoo Search Platform.";
        const encodedMessage = encodeURIComponent(message);
        const encodedWhatsAppNumber = encodeURIComponent(whatsappNumber);
        const whatsappUrl = `https://api.whatsapp.com/send?phone=${encodedWhatsAppNumber}&text=${encodedMessage}`;

        const whatsappPoint = {
            profileId: id,
            type: "whatsapp",
        };

        if (id) {
            const res = await HttpClient.requestData(
                "getting-rewards",
                "POST",
                whatsappPoint
            );
            if (res && res?.status) {
                toast.success("Redirecting to the WhatsApp App...");
            } else {
                console.log("Cant add points");
            }

            window.open(whatsappUrl, "_blank");
        }
    };

    const removeMember = async (contact, e) => {
        const deleteId = contact?.myContact?._id ? contact?.myContact?._id : null;
        e.stopPropagation(); // Stop event propagation
        const res = await HttpClient.requestData("delete-contacts/" + deleteId, "DELETE");
        if (res && res?.status) {
            toast.success("Contact Deleted");
            reloadList();
        } else {
            toast.error("Delete Failed");
        }
    };

    const joinChat = (_id) => {
        dispatch(OnetoOneChatIdname(_id));
        navigate("/chat");
    };

    const hideOnOutsideClick = (event) => {
        if (!event.target.closest('.iommdot')) {
            setdeleteWhatsappModalOpenClose(false);
            setClickedIndex(null);
            dispatch(ProfileSubmenuDropDown(false));
        }
    };

    useEffect(() => {
        if (deleteWhatsappModalOpenClose) {
            document.addEventListener('mousedown', hideOnOutsideClick);
        } else {
            document.removeEventListener('mousedown', hideOnOutsideClick);
        }
        return () => {
            document.removeEventListener('mousedown', hideOnOutsideClick);
        };
    }, [deleteWhatsappModalOpenClose]);

    const confirmMessage = (e, msgText, contact) => {
        e.preventDefault()
        confirmAlert({
            title: (
                <h4>Confirm delete</h4>
            ),
            message: (
                <p>
                    {msgText}
                </p>
            ),
            buttons: [
                {
                    label: "Yes",
                    onClick: () => removeMember(contact, e),
                    className: 'btn btn-primary',
                },
                {
                    label: "No",
                    className: 'btn btn-secondary',
                },
            ],
        });
    }


    return (
        <div className="buttonwrap_asse">
            <div
                className="iommdot"
                onClick={(e) => {
                    e.stopPropagation();
                    openDelet(
                        contact?.nonmemberDetails?._id,
                        contact?.nonmemberDetails?.mobileNo
                    );
                    dispatch(ProfileSubmenuDropDown(false));
                }}
            >
                <i className="fa-solid fa-ellipsis"></i>

                {clickedIndex === contact?.nonmemberDetails?._id &&
                    deleteWhatsappModalOpenClose && (
                        <div className="dropDelete">
                            <ul>
                                <li>
                                    <i
                                        className="fa-brands fa-square-whatsapp whatsapp"
                                        onClick={(e) =>
                                            whatsAppRedirection(
                                                e,
                                                contact?.nonmemberDetails
                                                    ?.whats_code,
                                                contact?.nonmemberDetails
                                                    ?.whatsappNo,
                                                contact?.nonmemberDetails?._id
                                            )
                                        }
                                        title="WhatsApp"
                                    ></i>
                                </li>
                                <li>
                                    <i
                                        className="fa-solid fa-trash-can trash"
                                        onClick={(e) => confirmMessage(e, "Are you sure you want to delete this contact?", contact)}
                                        title="Delete Contact"
                                    ></i>
                                </li>
                                <li>
                                    <a
                                        href={`tel:${contact?.nonmemberDetails?.phone_code}${contact?.nonmemberDetails?.mobileNo}`}
                                        className="callButton "
                                        title="Call"
                                    >
                                        <figure className="drctrCntctIconOpenDel">
                                            <img
                                                src={call}
                                                alt="img"
                                                className="img-fluid"
                                            />
                                        </figure>
                                    </a>
                                </li>
                                {
                                    contact?.nonmemberDetails?.memberStatus &&
                                    <li>
                                        <a className="callButton " title="Chat" >
                                            <figure className="drctrCntctIconOpenDel">
                                                <img
                                                    src={chatIcon}
                                                    alt="img"
                                                    className="img-fluid"
                                                    onClick={() =>
                                                        joinChat(contact?.nonmemberDetails?._id)
                                                    }
                                                />
                                            </figure>
                                        </a>
                                    </li>
                                }

                            </ul>
                        </div>
                    )}
            </div>
        </div>
    );
}